<template>
  <div class="login">
    <div class="cl-logo">
      <img src="../../assets/images/newLogo.png" class="cl-cloudImage">
      <el-button class="cl-changeLanguage" @click="goEnglish" size="mini" round>English</el-button>
      <el-button class="cl-register" @click="register" size="mini" round>注册</el-button>
    </div>
    <div class="cl-loginCard">
      <div class="cl-loginlogo">
        <img src="../../assets/images/loginlogo.png">
      </div>
      <div class="cl-form">
        <el-form :inline="true" :model="ruleForm" :rules="rules" ref="ruleForm">
          <el-form-item prop="telPhone" class="cl-tel">
            <el-input
              style="width: 230px;"
              placeholder="请输入手机号码"
              v-model="ruleForm.telPhone"
              maxlength="11"
              oninput="value=value.replace(/[^\d]/g,'')">
              <i slot="prefix" class="el-input__icon el-icon-mobile-phone"></i>
            </el-input>
          </el-form-item>
          <el-form-item prop="validateCode" class="cl-code">
            <el-input
              style="width: 230px;"
              oninput="value=value.replace(/[^\d]/g,'')"
              placeholder="请输入验证码"
              maxlength="6"
              v-model="ruleForm.validateCode">
              <i slot="prefix" class="el-input__icon el-icon-key"></i>
            </el-input>
          </el-form-item>
          <el-button class="cl-getCode" @click="sendMobileCode" :disabled="disabled">{{message}}</el-button>
          <el-button class="cl-logButton" @click="login('ruleForm')">登录</el-button>
        </el-form>
      </div>

      <el-dialog :visible.sync="centerDialogVisible" center width="440px" @close="closeDialog" :close-on-click-modal="false">
        <div class="cl-imgbox">
          <img src="../../assets/images/loginlogo.png" class="cl-registerlogo">
        </div>
        <el-form :model="registerForm" :rules="registerRules" ref="registerForm" class="demo-ruleForm">
          <el-form-item prop="realName">
            <el-input
              placeholder="请输入姓名"
              v-model="registerForm.realName"
              maxlength="20">
            </el-input>
          </el-form-item>
          <el-form-item prop="companyNameCn">
            <el-input
              placeholder="请输入公司中文名"
              v-model="registerForm.companyNameCn"
              maxlength="30">
            </el-input>
          </el-form-item>
          <el-form-item prop="companyNameEn">
            <el-input
              placeholder="请输入公司英文名"
              v-model="registerForm.companyNameEn"
              maxlength="70">
            </el-input>
          </el-form-item>
          <el-form-item prop="cityId">
            <el-autocomplete
              v-model="registerForm.cityId"
              value-key="regionName"
              :fetch-suggestions="querySearchAsync"
              placeholder="请选择业务所在地"
              @select="handleSelect"
              style="width: 100%;">
            </el-autocomplete>
          </el-form-item>
          <el-form-item prop="mobile">
            <el-input
              placeholder="请输入手机号"
              v-model="registerForm.mobile"
              maxlength="11"
              oninput="value=value.replace(/[^\d]/g,'')">
            </el-input>
          </el-form-item>
          <el-form-item prop="verifyCode">
            <el-input style="width: 265px;"
              placeholder="请输入验证码"
              maxlength="6"
              oninput="value=value.replace(/[^\d]/g,'')"
              v-model="registerForm.verifyCode">
            </el-input>
            <el-button class="cl-getregistercode" :disabled="registerDisabled" @click="getregisterCode">{{registerMessage}}</el-button>
          </el-form-item>
          <el-checkbox v-model="registerForm.checked">我已阅读并同意<a>《云钱账户注册协议》</a></el-checkbox>
          <el-button class="cl-registerButton" @click="successRegister('registerForm')">注册</el-button>
        </el-form>
      </el-dialog>
    </div>
    <div style="position:absolute;bottom:50px;width:100%;color:#B28814;font-size:18px;font-weight: bold;">
      <div class="namediv2" >
        <span class="copyright1"><a target="_blank" style="display:inline-block;text-decoration: underline;" href="http://beian.miit.gov.cn">辽ICP备：辽B-2-4-20080120-23</a> COPYRIGHT © 2019 WIFFA SHIPPINGTECH CO., LTD. All RIGHTS RESERVED  大连万发联合航贸科技有限公司</span>
      </div>
      </div>
  </div>
</template>

<script>
  export default {
    name: 'index',
    data() {
      return {
        message: "获取验证码",
        registerMessage: "获取验证码",
        disabled:false,
        registerDisabled:false,
        centerDialogVisible:false,
        ruleForm: {
          telPhone: '',
          validateCode: '',
        },
        rules: {
          telPhone: [
            { required: true, message: '请输入手机号', trigger: ['change']},
            { validator: this.$iValidate.phone, message: '格式不正确', trigger: ['blur'] }
          ],
          validateCode: [
            { required: true, message: '请输入验证码', trigger: ['change'] }
          ]
        },
        registerForm: {
          realName: '',
          companyNameCn: '',
          companyNameEn: '',
          cityName: '',
          checked: false,
          type: [],
          mobile: '',
          verifyCode: ''
        },
        registerRules: {
          realName: [
            { required: true, message: '请输入姓名', trigger: ['change'] },
          ],
          companyNameCn: [
            { required: true, message: '请输入公司中文名', trigger: ['change'] }
          ],
          companyNameEn: [
            { required: true, message: '请输入公司英文名', trigger: ['change'] }
          ],
          cityId: [
            { required: true, message: '请选择业务所在地', trigger: ['change'] }
          ],
          mobile: [
            { required: true, message: '请输入手机号', trigger: ['change'] },
            { validator: this.$iValidate.phone, message: '格式不正确', trigger: ['change'] }
          ],
          verifyCode: [
            { required: true, message: '请输入验证码', trigger: ['change'] }
          ]
        },
      }
    },
    created() {

    },
    mounted() {

    },
    methods: {
      goEnglish() {
        this.$router.push({
          name: "loginEn",
          query: {}
        })
      },
      register() {
        this.centerDialogVisible = true
      },
      // 中文登录
      login(formName) {
        this.$refs[formName].validate((valid) => {
          if(valid) {
            this.$axios.post('/clientUserLoginCn/login', {
              "mobile": this.ruleForm.telPhone,
              "verifyCode": this.ruleForm.validateCode
            })
            .then(response => {
              console.log("中文登录接口数据返回");
              console.log(response)
              if(response.code == 0) {
                localStorage.setItem('locale', 'zh')
                this.$i18n.locale = localStorage.getItem('locale')
                this.$router.push({
                  name: "personaloverview"
                })
              }else{
                this.$message.error(response.msg)
              }
            })
            .catch(error => {
              console.log(error);
              this.abnormalSituation()
            });
          }else {
            console.log('error submit!!');
            return false;
          }
        });
      },
      //给手机发送验证码
      sendMobileCode() {
        //清除表单校验结果
        // this.$refs.ruleForm.clearValidate()
        if(!(/^1[3456789]\d{9}$/.test(this.ruleForm.telPhone))){
          this.$message.error('请输入正确的手机号')
          return
        }
        this.$axios.get('/clientUserLoginCn/sendMobileCode', {
          params: {
            mobile: this.ruleForm.telPhone
          }
        })
        .then(response => {
          console.log("发送验证码接口数据");
          console.log(response)
          if (response.code == 0) {

            if (!this.timer) {
              this.count = 120;
              this.timer = setInterval(() => {
                if (this.count > 0 && this.count <= 120) {
                  this.count--;
                  this.message = '倒计时' + this.count + 's'
                  this.disabled = true
                }else {
                  clearInterval(this.timer);
                  this.timer = null;
                  this.message = '重新获取'
                  this.disabled = false
                }
              }, 1000)
            }

          }else{
            this.$message.error(response.msg)
          }
        })
        .catch(error => {
          console.log(error);
          this.abnormalSituation()
        });
      },
      //中文注册
      successRegister(formName) {
        this.$refs[formName].validate((valid) => {
          if(valid){
            if(this.registerForm.checked != true){
              this.$message.error('请阅读并同意《云钱账户注册协议》')
              return
            }
            this.$axios.post('/registCn/register', {
              "realName": this.registerForm.realName,
              "companyNameCn": this.registerForm.companyNameCn,
              "companyNameEn": this.registerForm.companyNameEn,
              "cityId": this.cityId,
              "mobile": this.registerForm.mobile,
              "verifyCode": this.registerForm.verifyCode,
              "agreeFlag": '1'
            })
            .then(response=> {
              if(response.code == 0){
                localStorage.setItem('locale', 'zh')
                this.$i18n.locale = localStorage.getItem('locale')
                this.$router.push({
                  name: "personaloverview"
                })
                this.centerDialogVisible = false
              }else{
                this.$message({
                  type: 'error',
                  message: response.msg
                });
              }
            })
            .catch(error=> {
              console.log(error);
              this.abnormalSituation()
            })
          }else{
            console.log('error submit!!');
            return false;
          }
        })
      },
      //城市下拉选(检索)
      querySearchAsync(queryString, cb) {
        var results = [];
        if(queryString) {
          this.$axios.get('/country/list',{
            params: {
              "type": "CN",
              "key": queryString
            }
          })
          .then(response=> {
            if(response.code==0){
              results = response.data;
            }
          })
          .catch(error=> {
            console.log(error);
            this.abnormalSituation()
          })
        }else {
          this.$axios.get('/country/list',{
            params: {
              "type": "CN"
            }
          })
          .then(response=> {
            if(response.code==0){
              results = response.data;
            }
          })
          .catch(error=> {
            console.log(error);
            this.abnormalSituation()
          })
        }
        clearTimeout(this.timeout);
        this.timeout = setTimeout(() => {
          cb(results);
        }, 1000);
      },
      //城市下拉选change事件
      handleSelect(item) {
        console.log(item);
        this.cityId = item.regionId;
        this.countryId = item.countryId;
      },
      closeDialog(){
        this.$refs['registerForm'].resetFields()
        this.registerForm.checked = false
        if(this.timer){
          clearInterval(this.timer);
          this.timer = null;
          this.registerMessage = '获取验证码'
          this.registerDisabled = false
        }
      },

      //获取注册验证码
      getregisterCode(){
        if(!(/^1[3456789]\d{9}$/.test(this.registerForm.mobile))){
          this.$message.error('请输入正确的手机号')
          return
        }
        this.$axios.get('/registCn/sendMobileCode', {
          params: {
            mobile: this.registerForm.mobile
          }
        })
        .then(response => {
          console.log("发送验证码接口数据");
          console.log(response)
          if (response.code == 0) {

            if (!this.timer) {
              this.count = 120;
              this.timer = setInterval(() => {
                if (this.count > 0 && this.count <= 120) {
                  this.count--;
                  this.registerMessage = '倒计时' + this.count + 's'
                  this.registerDisabled = true
                }else {
                  clearInterval(this.timer);
                  this.timer = null;
                  this.registerMessage = '重新获取'
                  this.registerDisabled = false
                }
              }, 1000)
            }

          }else{
            this.$message.error(response.msg)
          }
        })
        .catch(error => {
          console.log(error);
          this.abnormalSituation()
        });
      }
    },
    components: {

    }
  }
</script>
<style scoped>
  .login {
    background-color: rgb(240, 242, 245);
    position: relative;
    width: 100%;
    height: 100%;
    background-image: url("../../assets/images/cloudplatform.png");
    background-repeat: no-repeat;
    background-size: 100% 100%;
    background-position: center center;
    background-attachment: fixed
  }
  .cl-changeLanguage{
    background-color: #fd7d00 !important;
    color: white !important;
    float: right;
    margin: 0;
    margin-right: 30px;
    width: 70px;
    border: #fd7d00 solid 1px !important;
  }
  .cl-register{
    background-color: #fd7d00 !important;
    color: white !important;
    float: right;
    margin: 0;
    margin-right: 20px;
    width: 70px;
    border: #fd7d00 solid 1px !important;
  }
  .cl-logo{
    padding-top:2%;
    padding-left:2%;
    width: auto;
  }
  .cl-cloudImage{
    width: auto;
    height: 140px;
    width: 500px;
    position: absolute;
  }
  .cl-loginlogo{
    text-align: center;
    margin: 0;
    margin-top: 9%;
  }
  .cl-loginlogo img{
    width: auto;
    height: 55px;
  }
  .cl-form{
    margin-top: 4%;
    width: 100%;
    height: 40px;
    text-align: center;
  }
  .cl-tel{
    margin-top: 0px;
  }
  .cl-code{
    /* margin-top: 0px; */
  }
  .cl-getCode{
    width: 120px;
    height: 40px;
    background-color: #fd7d00 !important;
    border: #fd7d00 solid 1px !important;
    color: white !important;
  }
  .cl-logButton{
    width: 120px;
    height: 40px;
    background-color: #d5aa5e !important;
    border: #d5aa5e solid 1px !important;
    color: white  !important;
  }
  .cl-info{
    position: absolute;
    bottom: 10px;
    margin-left:2%;
    width: 98%;
  }
  .cl-telImage{
    width: auto;
    height: 35px;
  }
  .cl-text{
    float: right;
    margin-top: 20px;
    margin-right: 20px;
    bottom: 0px;
    font-size: 8px;
    font-family:"微软雅黑";
    color: dimgrey;
  }
  .demo-ruleForm{
    margin-top: 20px;
  }
  .cl-imgbox{
    text-align: center;
    margin: 0;
    margin-top: -40px;
  }
  .cl-registerlogo{
    width: auto;
    height: 35px;
  }
  .cl-registerButton{
    margin-top: 20px;
    width: 390px;
    background-color: #d5aa5e !important;
    border: #d5aa5e solid 1px !important;
    color: white !important;
  }
  .cl-getregistercode{
    width: 120px;
    background-color: #d5aa5e !important;
    color: white !important;
    border: #d5aa5e solid 1px !important;
  }
  .namediv2{
    width: 100%;
    display: flex;
    justify-content: center;
  }
/*  /deep/ .el-dialog--center .el-dialog__body{
    padding-top: 25px;
    padding-bottom: 10px;
    padding-left: 25px;
    padding-right: 25px;
  } */
</style>
